import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Fonts are bundled rather than loaded from Google, so no visitor's address
// goes to Google before they've agreed to anything, and every weight the
// styles use (300 to 700) exists instead of 700 being faked.
import '@fontsource-variable/dm-sans';
import '@fontsource-variable/cormorant-garamond/wght.css';
import '@fontsource-variable/cormorant-garamond/wght-italic.css';
import { applyBrandTheme } from './lib/brand';
import { registerServiceWorker } from './lib/push';

// Apply per-deployment brand overrides (colours + document title) before render.
applyBrandTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
// React.StrictMode removed — causes Supabase auth lock to be orphaned on
// the double-mount cycle, producing a 5s stall before login completes.
root.render(<App />);
registerServiceWorker();
